module.exports = __webpack_public_path__ + "static/media/top_10_horizontal.65f1b97c.png";